<script>
  import { pages } from './stores/search-pages.store.js';
  import PageCard from './PageCard.svelte';
</script>

<div class="grid grid-cols-1 lg:grid-cols-3 gap-x-2 gap-y-4 max-w-[1134px] m-auto mb-[100px]">
  {#each $pages as page}
    <PageCard {page} />
  {/each}
</div>